import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  heading: 'Evaluează serviciul primit',
  loading: 'Se încarcă...',
  notFound: 'Această livrare nu a fost găsită.',
  deliveredOn: 'Livrat la {{date}}',
  byProvider: 'Furnizor: {{name}}',
  ratingLabel: 'Notă (1-5)',
  commentsLabel: 'Comentarii (opțional)',
  submitButton: 'Trimite evaluarea',
  submittingButton: 'Se trimite...',
  submitError: 'Trimiterea evaluării nu a reușit.',
  thankYouTitle: 'Mulțumim pentru evaluare!',
  thankYouBody: 'Răspunsul dumneavoastră a fost înregistrat.',
  alreadyEvaluatedTitle: 'Această livrare a fost deja evaluată',
  alreadyEvaluatedBody: 'Evaluare înregistrată: {{rating}}/5{{comments}}',
} as const;

const en = {
  heading: 'Rate the service you received',
  loading: 'Loading…',
  notFound: 'This delivery was not found.',
  deliveredOn: 'Delivered on {{date}}',
  byProvider: 'Provider: {{name}}',
  ratingLabel: 'Rating (1–5)',
  commentsLabel: 'Comments (optional)',
  submitButton: 'Submit evaluation',
  submittingButton: 'Submitting…',
  submitError: 'Submitting the evaluation failed.',
  thankYouTitle: 'Thank you for your feedback!',
  thankYouBody: 'Your response has been recorded.',
  alreadyEvaluatedTitle: 'This delivery has already been evaluated',
  alreadyEvaluatedBody: 'Recorded evaluation: {{rating}}/5{{comments}}',
} satisfies Translation<keyof typeof ro>;

export const serviceEvaluationPage = { ro, en } satisfies Dictionary;

export type ServiceEvaluationPageKey = keyof typeof ro;
